function getIP(json) {
  if (json.countryCode) {
    //GEO Buttons
    if (!customElements.get('geo-buttons')) {
      let hasGeoButton = false;
      // Show/hide button based on country code
      const GeoBtns = document.querySelectorAll('[data-geo-location]');
      const DefaultButton = document.querySelector('[data-default-button]');


      //Loop trough GeoBtns and check if the country code matches, if so remove class hidden.
      if (GeoBtns) {
        GeoBtns.forEach(function(button) {
          if (button.dataset.geoLocation === json.countryCode ){
            button.classList.remove('hidden');
            hasGeoButton = true;
          }
        });

        // if no GEO buttons match and there is a default button set
        if (DefaultButton) {
          if (!hasGeoButton) {
            DefaultButton.classList.remove('hidden');
          }
        }
      }
    }

    // Expected Delivery
    if (!customElements.get('expected-delivery')) {
      const expectedDeliveryTime = document.querySelector('.product-delivery-time');

      if (expectedDeliveryTime) {
        expectedDeliveryTime.style.display = 'none';
        const locationSelect = expectedDeliveryTime.querySelector('select[name="location"]');
        const defaultLocation = expectedDeliveryTime.dataset.defaultLocation;
        const defaultRegion = expectedDeliveryTime.dataset.defaultRegion;
        const countryData = JSON.parse(expectedDeliveryTime.dataset.objectData);
        const currentLanguage = expectedDeliveryTime.dataset.currentLanguage;

        // Default values
        let deliveryDays = 3;
        let orderBeforeHours = 12;
        let country = json.country;
        let region = '';
        let countryCode  = json.countryCode;
        let currentTimezone = json.timezone;
        let locationTimezone = json.timezone;
        let noDeliveryDates = '';
        let neverDeliverOn = '';
        let localization = currentLanguage + '-' + countryCode;

        if (defaultLocation != '' && defaultLocation != 'undefined' && defaultLocation != 'null') {
          localization = currentLanguage + '-' + defaultLocation;
        }

        if (countryData) {
          countryData.forEach(function(location) {

            // Location country and region same as user location
            if (location.countryCode === json.countryCode && location.region === json.region) {
              region = location.region;
              countryCode = location.countryCode;
              locationTimezone = location.timeZone;
              let locationData = countryData.find(location => location.countryCode === json.countryCode);

              if (region && region !== 'undefined' && region !== 'null' && region !== '' && location.region === region) {
                locationData = countryData.find(location => location.countryCode === json.countryCode && location.region === region);
              }

              deliveryDays = parseInt(locationData.days);
              orderBeforeHours = parseInt(locationData.hours);
              country = locationData.country;
              countryCode = locationData.countryCode;
              locationTimezone = locationData.timeZone;
              noDeliveryDates = locationData.noDeliveryDates;
              neverDeliverOn = locationData.neverDeliverOn;

              if (currentLanguage != '' && currentLanguage != 'undefined' && currentLanguage != 'null') {
                localization = currentLanguage + '-' + countryCode;
              } else {
                localization = countryCode
              }

              window.ipLocation = {
                deliveryDays: deliveryDays,
                noDeliveryDates: noDeliveryDates,
                orderBeforeHours: orderBeforeHours,
                localization: localization,
                currentTimezone: currentTimezone,
                locationTimezone: locationTimezone,
                neverDeliverOn: neverDeliverOn
              }
            }

             // Location country as user location
            if (location.countryCode === json.countryCode && location.region !== json.region) {
              region = location.region;
              let locationData = countryData.find(location => location.countryCode === json.countryCode);
              if (region && region !== 'undefined' && region !== 'null' && region !== '') {
                locationData = countryData.find(location => location.countryCode === json.countryCode && location.region === region);
              }
              deliveryDays = parseInt(locationData.days);
              orderBeforeHours = parseInt(locationData.hours);
              country = locationData.country;
              countryCode = locationData.countryCode;
              locationTimezone = locationData.timeZone;
              noDeliveryDates = locationData.noDeliveryDates;
              neverDeliverOn = locationData.neverDeliverOn;

              if (currentLanguage != '' && currentLanguage != 'undefined' && currentLanguage != 'null') {
                localization = currentLanguage + '-' + countryCode;
              } else {
                localization = countryCode
              }

              window.ipLocation = {
                deliveryDays: deliveryDays,
                noDeliveryDates: noDeliveryDates,
                orderBeforeHours: orderBeforeHours,
                localization: localization,
                currentTimezone: currentTimezone,
                locationTimezone: locationTimezone,
                neverDeliverOn: neverDeliverOn
              }
            }

            // Default location for when user location is not found or does not match
            if (defaultLocation && defaultLocation !== 'undefined' && defaultLocation !== 'null' && defaultLocation !== '') {
              region = defaultRegion;

              let defaultLocationData = countryData.find(location => location.countryCode === defaultLocation);
              if (region && region !== 'undefined' && region !== 'null' && region !== '') {
                defaultLocationData = countryData.find(location => location.countryCode === defaultLocation && location.region === region);
              }

              deliveryDays = parseInt(defaultLocationData.days);
              orderBeforeHours = parseInt(defaultLocationData.hours);
              country = defaultLocationData.country;
              countryCode = defaultLocationData.countryCode;
              locationTimezone = defaultLocationData.timeZone;
              noDeliveryDates = defaultLocationData.noDeliveryDates;
              neverDeliverOn = defaultLocationData.neverDeliverOn;

              if (currentLanguage != '' && currentLanguage != 'undefined' && currentLanguage != 'null') {
                localization = currentLanguage + '-' + countryCode;
              } else {
                localization = countryCode
              }


              window.ipLocation = {
                deliveryDays: deliveryDays,
                noDeliveryDates: noDeliveryDates,
                orderBeforeHours: orderBeforeHours,
                localization: localization,
                currentTimezone: currentTimezone,
                locationTimezone: locationTimezone,
                neverDeliverOn: neverDeliverOn
              }
            }
          });
        }

        if (locationSelect) {
          // Update the location select
          const selectedLocationOptions = locationSelect.querySelectorAll('option');
          // When default location is set
          if (defaultLocation && defaultLocation !== 'undefined' && defaultLocation !== 'null' && defaultLocation !== '') {
            selectedLocationOptions.forEach(function(option) {
              if (option.value === defaultLocation) {
                option.selected = true;
              } else {
                option.selected = false;
              }
            });
          }

          // When default location and region is set
          if (defaultRegion && defaultRegion !== 'undefined' && defaultRegion !== 'null' && defaultRegion !== '') {
            selectedLocationOptions.forEach(function(option) {
              if (option.value === defaultLocation && option.dataset.region === defaultRegion) {
                option.selected = true;
              } else {
                option.selected = false;
              }
            });
          }
          //when no default location is set
          if (defaultLocation == 'undefined' || defaultLocation == 'null' || defaultLocation == '') {
            selectedLocationOptions.forEach(function(option) {
              if (option.value === json.countryCode) {
                option.selected = true;
              } else {
                option.selected = false;
              }
            });
          }

          locationSelect.addEventListener('change', function() {
            const selectedLocationOptions = locationSelect.querySelectorAll('option');
            selectedLocationOptions.forEach(function(option) {
              if (option.selected) {
                const selectedLocation = option.value;
                const selectedRegion = option.dataset.region;

                let selectedLocationData = countryData.find(location => location.countryCode === selectedLocation);
                if (selectedRegion && selectedRegion !== 'undefined' && selectedRegion !== 'null' && selectedRegion !== '') {
                  selectedLocationData = countryData.find(location => location.countryCode === selectedLocation && location.region === selectedRegion);
                }
                if (selectedLocationData) {
                  const deliveryDays = parseInt(selectedLocationData.days);
                  const orderBeforeHours = parseInt(selectedLocationData.hours);
                  country = selectedLocationData.country;
                  countryCode = selectedLocationData.countryCode;
                  locationTimezone = selectedLocationData.timeZone;
                  region = selectedLocationData.region;
                  noDeliveryDates = selectedLocationData.noDeliveryDates;
                  neverDeliverOn = selectedLocationData.neverDeliverOn;

                  if (selectedLocationData.region_name !== '') {
                    region = selectedLocationData.region_name;
                  }

                  if (currentLanguage != '' && currentLanguage != 'undefined' && currentLanguage != 'null') {
                    localization = currentLanguage + '-' + countryCode;
                  } else {
                    localization = countryCode
                  }

                  window.ipLocation = {
                    deliveryDays: deliveryDays,
                    noDeliveryDates: noDeliveryDates,
                    orderBeforeHours: orderBeforeHours,
                    localization: localization,
                    currentTimezone: currentTimezone,
                    locationTimezone: locationTimezone,
                    neverDeliverOn: neverDeliverOn
                  }

                  window.intervalId ? clearInterval(window.intervalId) : console.log('clear interval');
                }
              }
            });
          });
        }
      }
    }
  }
}